import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Püsikliendina säästaksid

  <span style="color:#85c1dc;">**FI:**</span>
  Alennus ON24 kanta-asiakkaalle

  <span style="color:#85c1dc;">**RU:**</span>
  Экономия для клиентов
*/
/* @__NO_SIDE_EFFECTS__ */
const m153 = msg(
  mf`Püsikliendina säästaksid`,
  mf`Alennus ON24 kanta-asiakkaalle`,
  mf`Экономия для клиентов`,
)

export { m153 as 'w.basket.summary.customer_potential_savings' }